import { ProjectsInterface } from '../../../types/projects';

export const projectsInitialState: ProjectsInterface = {
  projects: [],
};
